const state = {
    productCategory : null
}

const getters = {
    getProductCategory : state => {
        return state.productCategory
    }
}

const mutations = {
    productCategoryStatus (state, productCategory){
        if(productCategory){
            state.productCategory = productCategory;
        } else {
            state.productCategory = null;
        }
    }
}

const actions = {
    setProductCategory ({ commit }, productCategory){
        commit('productCategoryStatus', productCategory);
    }
}

export default{
    state,
    getters,
    mutations,
    actions
}